export default __webpack_public_path__ + "static/media/Miami_Hack_Week.850f7c50.svg";